<section *ngIf="panelVisible" class="operational-readiness-panel">
    <header class="operational-readiness-panel__header" *ngIf="!hidePanelHeading">
        <div>
            <h2 class="operational-readiness-panel__title">Operational Readiness</h2>
            <p class="operational-readiness-panel__intro">
                Current operational status for this organization.
            </p>
        </div>
    </header>

    <app-operational-warning-card
            *ngIf="loadErrorWarning as warning"
            [warning]="warning">
    </app-operational-warning-card>

    <ng-container *ngIf="!loadError">
        <app-operational-section-shell
                title="Organization & Identity"
                subtitle="Tenant identity and administrator readiness."
                [summary]="identitySummary"
                [loading]="loading"
                [emptyMessage]="!loading && !identityCards.length ? 'No identity checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of identityCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>

        <app-operational-section-shell
                title="Infrastructure"
                subtitle="Bridges, credentials, cameras, and webhook API keys."
                [summary]="infrastructureSummary"
                [loading]="loading"
                [emptyMessage]="!loading && !infrastructureCards.length ? 'No infrastructure checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of infrastructureCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>

        <app-operational-section-shell
                title="Vision Platform"
                subtitle="Analytics, camera analytics, correlation, and vehicle detection."
                [summary]="visionSummary"
                [loading]="loading"
                [emptyMessage]="!loading && !visionCards.length ? 'No vision checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of visionCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>

        <app-operational-section-shell
                title="Integration Services"
                subtitle="Platform vision providers, authentication, and event subscriptions."
                [summary]="integrationSummary"
                [loading]="loading"
                [emptyMessage]="!loading && !integrationCards.length ? 'No integration checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of integrationCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>

        <app-operational-section-shell
                title="Vehicle Processing"
                subtitle="Runtime ingestion, processing pipeline, and attention signals."
                [summary]="vehicleProcessingSummary"
                [loading]="loading"
                [emptyMessage]="!loading && !vehicleProcessingCards.length ? 'No vehicle processing checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of vehicleProcessingCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>

        <app-operational-section-shell
                title="Installation"
                subtitle="First vehicle detection evidence."
                [summary]="installationSummary"
                [loading]="loading"
                [emptyMessage]="!loading && !installationCards.length ? 'No installation checks available.' : ''">
            <app-operational-status-card
                    *ngFor="let card of installationCards"
                    [card]="card">
            </app-operational-status-card>
        </app-operational-section-shell>
    </ng-container>
</section>
